module.exports = __webpack_public_path__ + "img/theme.9648fdb9.svg";